<template>
  <div
    class="iframe-edit__add-placeholder flex justify-center items-center pa-8 rounded-2 overflow-hidden"
    :style="{ width: `${data?.width}`, height: `${data?.height}` }"
  >
    <CIcon :color="themeVars.primary4" :icon="ComponentIcon.IFrame" size="36" />
  </div>
</template>

<script setup lang="ts">
import useThemeVars from '@lib/composables/useThemeVars'
import type { IFrameProps } from '@canvas-builder/types/canvas'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import { ComponentIcon } from '@canvas-builder/types/canvas'

defineProps<{
  data?: IFrameProps
}>()

const themeVars = useThemeVars()
</script>

<style scoped lang="scss">
.iframe-edit__add-placeholder {
  background: v-bind('themeVars.primary6');
}
</style>
